import { useTranslation } from 'react-i18next';
import { useStore } from '@/utils/store';
import Toast from './Toast';

export default function ToastContainer() {
  const { t } = useTranslation();
  const toasts = useStore((s) => s.toasts);
  const removeToast = useStore((s) => s.removeToast);

  if (toasts.length === 0) return null;

  const resolveMessage = (msg) => {
    // Budget notifications come as "budget.warning.food" or "budget.exceeded.food"
    if (msg.startsWith('budget.warning.')) {
      const cat = msg.replace('budget.warning.', '');
      return t('notifications.budgetWarning', { category: t(`categories.${cat}`) });
    }
    if (msg.startsWith('budget.exceeded.')) {
      const cat = msg.replace('budget.exceeded.', '');
      return t('notifications.budgetExceeded', { category: t(`categories.${cat}`) });
    }
    return msg;
  };

  return (
    <div className="fixed top-4 right-4 z-[60] flex flex-col gap-2 w-80 max-w-[calc(100vw-2rem)]" aria-live="polite">
      {toasts.map((toast) => (
        <Toast key={toast.id} {...toast} message={resolveMessage(toast.message)} onDismiss={removeToast} />
      ))}
    </div>
  );
}
